<template>
  <v-toolbar color="primary" extended :extension-height="200">
    <div class="pt-16 px-10 white--text full-width">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <div class="white" style="width: 40px; height: 80px;" />
          <div class="text-h2 ml-4">Open Africa Power 2021</div>
        </div>
        <v-img :src="enelLogoWhite" :width="163" :max-width="163" />
      </div>
    </div>
    <div slot="extension" class="px-10 pt-6 white--text">
      <div class="text-h4 font-weight-light">
        Forging a new generation<br />of clean energy leaders for Africa
      </div>
    </div>
  </v-toolbar>
</template>

<script>
import enelLogoWhite from "@/assets/enel_logo_white.png";
export default {
  name: "BannerToolbar",
  data() {
      return {
          enelLogoWhite
      }
  }
};
</script>

<style lang="scss" scoped></style>
